<template>
  <div id="app">
    <div>
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

import { userMappers } from '@/store/modules/user'
import Loading from '@/components/ui/Loading.vue'
import { loggerMapper } from '@/store/modules/logger'
import { toastMapper } from '@/store/modules/toast'

const Mappers = Vue.extend({
  computed: {
    ...loggerMapper.mapState(['logs']),
    ...userMappers.mapState(['user']),
    ...userMappers.mapGetters(['isAuthenticated']),
  },
  methods: {
    ...loggerMapper.mapMutations(['addLog']),

    ...loggerMapper.mapActions(['sendLogs']),
    ...toastMapper.mapActions(['pushToast']),
  },
})
@Component({ components: { Loading } })
export default class App extends Mappers {
  private interval?: any
  private isUserExist: any = false

  private created() {
    window.onbeforeunload = null
    this.isUserExist = this.user && this.isAuthenticated

    if (this.isUserExist) {
      window.onbeforeunload = () => {
        this.sendLogs()
      }
      this.interval = setInterval(() => {
        this.sendLogs()
      }, 30000)
    }
    window.onunhandledrejection = (e: PromiseRejectionEvent) => {
      if (this.isUserExist) {
        this.addLog({
          userId: this.user?.id,
          severity: 'error',
          message: 'ERROR',
          page: this.$route.path,
          error: {
            type: e.type,
            message: e.reason.message,
            stack: e.reason.stack,
          },
          timestamp: Date.now(),
        })
        this.sendLogs()
      }
    }
    if (this.isUserExist) {
      this.addLog({
        userId: this.user?.id,
        severity: 'info',
        message: 'LOG IN',
        page: this.$route.path,
        timestamp: Date.now(),
      })
      this.sendLogs()
    }
  }
}
</script>

<style lang="scss">
@import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
@import './scss/app.scss';
@import '../node_modules/ag-grid-community/dist/styles/ag-grid.css';
@import '../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css';
@import './scss/vfg.scss';
@import '../node_modules/vue-form-generator/dist/vfg.css';
</style>
